// extracted by css-extract-rspack-plugin
export default {"ListViz":"GBJ_p","listViewDashcard":"qpWi_","dashboardListView":"MTYJb"};